import ToastHighLighter from '@/lib/ToastHighLighter';

export const BreadcrumbCode = () => {
  const language = 'html';
  const codeString = `
  // Breadcrumbs
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item home--icon" aria-current="page">
        Home
      </li>
    </ol>
  </nav>

  // Breadcrumb active
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a class="home--icon" href="/">
          Home
        </a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">
        Library
      </li>
    </ol>
  </nav>

  // Breadcrumb five levels
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a class="home--icon" href="#">
          Home
        </a>
      </li>
      <li class="breadcrumb-item">
        <a href="#">Library</a>
      </li>
      <li class="breadcrumb-item">
        <a href="#">Lorem ipsum</a>
      </li>
      <li class="breadcrumb-item">
        <a href="#">Dolor sit amet</a>
      </li>
      <li class="breadcrumb-item">
        <a href="#">Lorem, ipsum dolor.</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">
        Data
      </li>
    </ol>
  </nav>
  `;

  return (
    <>
      <ToastHighLighter
        name={'breadcrumb'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
